'use strict';

export default function possessiveFilter() {
  return function (properNoun) {
    if (!properNoun) {
      return properNoun;
    }

    let lastChar = properNoun.charAt(properNoun.length - 1);
    return (lastChar == 's' || lastChar == 'S') ? `${properNoun}'` : `${properNoun}'s`;
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/possessive.filter.js